import { render, staticRenderFns } from "./PDF_Questions.vue?vue&type=template&id=9a9e9cf6&scoped=true"
import script from "./PDF_Questions.vue?vue&type=script&lang=js"
export * from "./PDF_Questions.vue?vue&type=script&lang=js"
import style0 from "./PDF_Questions.vue?vue&type=style&index=0&id=9a9e9cf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9e9cf6",
  null
  
)

export default component.exports